import UserService from "../services/api/UserService";

const PrivateRoute = ({ children }) =>
  UserService?.isLoggedIn ? children : () => UserService?.doLogin();

export default PrivateRoute;
